export function objectKeysToLowerCase(object) {
  var key,
    keys = Object.keys(object);
  var n = keys.length;
  var newObj = {};
  while (n--) {
    key = keys[n];
    newObj[key.toLowerCase()] = object[key];
  }
  return newObj;
}

export const replaceAkeneoProdUrl = url => {
  if (url.startsWith('https://images.agidealersupport.com')) {
    return url.replace(
      'images.agidealersupport.com',
      'images.staging.agidealersupport.com'
    );
  }
  return url;
};
